import TimelineMax from 'assets/utilz/timeline';

export const emtpyTimeline = new TimelineMax();
